import { Module } from '../Module';

/**
* Adds hardReload() method to IStateService.
* This is needed because $state.reload() only re-executes resolve providers but does not re-execute
* the controllers that update scope
* See https://github.com/angular-ui/ui-router/issues/582#issuecomment-38117084 for more details
*/
Module.instance().config(<any[]>['$provide', ($provide: ng.auto.IProvideService) => {
  $provide.decorator('$state', ['$delegate', ($delegate: ng.ui.IStateService) => {
    $delegate.hardReload = () => {
      $delegate.transitionTo($delegate.current.name, $delegate.params, { reload: true, notify: true, inherit: false, location: false });
    };

    return $delegate;
  }]);
}]);
